export let data = [
  {
    OrderID: 10248,
    CustomerID: "VINET",
    EmployeeID: 5,
    OrderDate: new Date(8364186e5),
    ShipName: "Vins et alcools Chevalier",
    ShipCity: "Reims",
    ShipAddress: "59 rue de l Abbaye",
    ShipRegion: "CJ",
    ShipPostalCode: "51100",
    ShippedDate: new Date(8367642e5),
    ShipCountry: "France",
    Freight: 32.38,
    Verified: !0,
    Phon: 0.098919023412,
    Number2: 0.0045678,
    number3: -0.008765654,
    LastName: "Buchanan",
    FirstName: "Steven",
    mail: "Steven12@mail.com"
  },
  {
    OrderID: 10249,
    CustomerID: "TOMSP",
    EmployeeID: 6,
    OrderDate: new Date(836505e6),
    ShipName: "Toms Spezialitäten",
    ShipCity: "Münster",
    ShipAddress: "Luisenstr. 48",
    ShipRegion: "CJ",
    ShipPostalCode: "44087",
    ShippedDate: new Date(8367642e5),
    ShipCountry: "Germany",
    Freight: 11.61,
    Verified: !1,
    Phon: 0.18919023412,
    Number2: 0.0098678,
    number3: -0.002365654,
    mail: "Michael124@mail.com",
    LastName: "Suyama",
    FirstName: "Michael"
  },
  {
    OrderID: 10250,
    CustomerID: "HANAR",
    EmployeeID: 4,
    OrderDate: new Date(8367642e5),
    ShipName: "Hanari Carnes",
    ShipCity: "Rio de Janeiro",
    ShipAddress: "Rua do Paço, 67",
    ShipRegion: "RJ",
    ShipPostalCode: "05454-876",
    ShippedDate: new Date(8368506e5),
    ShipCountry: "Brazil",
    Freight: 65.83,
    Verified: !0,
    Phon: 0.38919023412,
    Number2: 0.01345678,
    number3: 0.038765654,
    LastName: "Peacock",
    FirstName: "Margaret",
    mail: "Margaret512@mail.com"
  },
  {
    OrderID: 10251,
    CustomerID: "VICTE",
    EmployeeID: 3,
    OrderDate: new Date(8367642e5),
    ShipName: "Victuailles en stock",
    ShipCity: "Lyon",
    ShipAddress: "2, rue du Commerce",
    ShipRegion: "CJ",
    ShipPostalCode: "69004",
    ShippedDate: new Date(8368506e5),
    ShipCountry: "France",
    Freight: 41.34,
    Verified: !0,
    Phon: 0.04919023412,
    Number2: 0.00123678,
    number3: -0.001765654,
    LastName: "Leverling",
    FirstName: "Janet",
    mail: "Janet12@mail.com"
  },
  {
    OrderID: 10252,
    CustomerID: "SUPRD",
    EmployeeID: 2,
    OrderDate: new Date(8368506e5),
    ShipName: "Suprêmes délices",
    ShipCity: "Charleroi",
    ShipAddress: "Boulevard Tirou, 255",
    ShipRegion: "CJ",
    ShipPostalCode: "B-6000",
    ShippedDate: new Date(8368506e5),
    ShipCountry: "Belgium",
    Freight: 51.3,
    Verified: !0,
    Phon: 0.078919023412,
    Number2: 0.00789678,
    number3: -0.009265654,
    LastName: "Fuller",
    FirstName: "Andrew",
    mail: "Andrew12@mail.com"
  },
  {
    OrderID: 10253,
    CustomerID: "HANAR",
    EmployeeID: 7,
    OrderDate: new Date(836937e6),
    ShipName: "Hanari Carnes",
    ShipCity: "Rio de Janeiro",
    ShipAddress: "Rua do Paço, 67",
    ShipRegion: "RJ",
    ShipPostalCode: "05454-876",
    ShippedDate: new Date(8368506e5),
    ShipCountry: "Brazil",
    Freight: 58.17,
    Verified: !0,
    Phon: 0.034519023412,
    Number2: 0.009886678,
    number3: -0.012765654,
    mail: "Robert7@mail.com",
    LastName: "King",
    FirstName: "Robert"
  },
  {
    OrderID: 10254,
    CustomerID: "CHOPS",
    EmployeeID: 5,
    OrderDate: new Date(8370234e5),
    ShipName: "Chop-suey Chinese",
    ShipCity: "Bern",
    ShipAddress: "Hauptstr. 31",
    ShipRegion: "CJ",
    ShipPostalCode: "3012",
    ShippedDate: new Date(8368506e5),
    ShipCountry: "Switzerland",
    Freight: 22.98,
    Verified: !1,
    Phon: 0.02349023412,
    Number2: -0.04132678,
    number3: -0.02365654,
    LastName: "Buchanan",
    FirstName: "Steven",
    mail: "Steven12@mail.com"
  },
  {
    OrderID: 10255,
    CustomerID: "RICSU",
    EmployeeID: 9,
    OrderDate: new Date(8371098e5),
    ShipName: "Richter Supermarkt",
    ShipCity: "Genève",
    ShipAddress: "Starenweg 5",
    ShipRegion: "CJ",
    ShipPostalCode: "1204",
    ShippedDate: new Date(8368506e5),
    ShipCountry: "Switzerland",
    Freight: 148.33,
    Verified: !0,
    Phon: 0.78919023412,
    Number2: 0.0067478,
    number3: -0.0087654,
    mail: "Anne2@mail.com",
    LastName: "Dodsworth",
    FirstName: "Anne"
  },
  {
    OrderID: 10256,
    CustomerID: "WELLI",
    EmployeeID: 3,
    OrderDate: new Date(837369e6),
    ShipName: "Wellington Importadora",
    ShipCity: "Resende",
    ShipAddress: "Rua do Mercado, 12",
    ShipRegion: "SP",
    ShipPostalCode: "08737-363",
    ShippedDate: new Date(8368506e5),
    ShipCountry: "Brazil",
    Freight: 13.97,
    Verified: !1,
    Phon: 0.08919023412,
    Number2: 0.00315678,
    number3: 0.0064654,
    LastName: "Leverling",
    FirstName: "Janet",
    mail: "Janet12@mail.com"
  },
  {
    OrderID: 10257,
    CustomerID: "HILAA",
    EmployeeID: 4,
    OrderDate: new Date(8374554e5),
    ShipName: "HILARION-Abastos",
    ShipCity: "San Cristóbal",
    ShipAddress: "Carrera 22 con Ave. Carlos Soublette #8-35",
    ShipRegion: "Táchira",
    ShipPostalCode: "5022",
    ShippedDate: new Date(8368506e5),
    ShipCountry: "Venezuela",
    Freight: 81.91,
    Verified: !0,
    Phon: 0.9919023412,
    Number2: 0.0045678,
    number3: 0.008765654,
    LastName: "Peacock",
    FirstName: "Margaret",
    mail: "Margaret512@mail.com"
  },
  {
    OrderID: 10258,
    CustomerID: "ERNSH",
    EmployeeID: 1,
    OrderDate: new Date(8375418e5),
    ShipName: "Ernst Handel",
    ShipCity: "Graz",
    ShipAddress: "Kirchgasse 6",
    ShipRegion: "CJ",
    ShipPostalCode: "8010",
    ShippedDate: new Date(8367642e5),
    ShipCountry: "Austria",
    Freight: 140.51,
    Verified: !0,
    Phon: 0.4519023412,
    Number2: 0.0099678,
    number3: -0.0021654,
    mail: "Margaret512@mail.com",
    LastName: "Davolio",
    FirstName: "Nancy"
  },
  {
    OrderID: 10259,
    CustomerID: "CENTC",
    EmployeeID: 4,
    OrderDate: new Date(8376282e5),
    ShipName: "Centro comercial Moctezuma",
    ShipCity: "México D.F.",
    ShipAddress: "Sierras de Granada 9993",
    ShipRegion: "CJ",
    ShipPostalCode: "05022",
    ShippedDate: new Date(8368506e5),
    ShipCountry: "Mexico",
    Freight: 3.25,
    Verified: !1,
    Phon: 0.08919023412,
    Number2: 0.0034678,
    number3: -0.00432654,
    LastName: "Peacock",
    FirstName: "Margaret",
    mail: "Margaret512@mail.com"
  },
  {
    OrderID: 10260,
    CustomerID: "OTTIK",
    EmployeeID: 4,
    OrderDate: new Date(8377146e5),
    ShipName: "Ottilies Käseladen",
    ShipCity: "Köln",
    ShipAddress: "Mehrheimerstr. 369",
    ShipRegion: "CJ",
    ShipPostalCode: "50739",
    ShippedDate: new Date(8368506e5),
    ShipCountry: "Germany",
    Freight: 55.09,
    Verified: !0,
    Phon: 0.019023412,
    Number2: 0.0076578,
    number3: 0.005456654,
    LastName: "Peacock",
    FirstName: "Margaret",
    mail: "Margaret512@mail.com"
  },
  {
    OrderID: 10261,
    CustomerID: "QUEDE",
    EmployeeID: 4,
    OrderDate: new Date(8377146e5),
    ShipName: "Que Delícia",
    ShipCity: "Rio de Janeiro",
    ShipAddress: "Rua da Panificadora, 12",
    ShipRegion: "RJ",
    ShipPostalCode: "02389-673",
    ShippedDate: new Date(8368506e5),
    ShipCountry: "Brazil",
    Freight: 3.05,
    Verified: !1,
    Phon: 0.2345023412,
    Number2: 0.0047978,
    number3: -0.002365654,
    LastName: "Peacock",
    FirstName: "Margaret",
    mail: "Margaret512@mail.com"
  },
  {
    OrderID: 10262,
    CustomerID: "RATTC",
    EmployeeID: 8,
    OrderDate: new Date(8379738e5),
    ShipName: "Rattlesnake Canyon Grocery",
    ShipCity: "Albuquerque",
    ShipAddress: "2817 Milton Dr.",
    ShipRegion: "NM",
    ShipPostalCode: "87110",
    ShippedDate: new Date(8367642e5),
    ShipCountry: "USA",
    Freight: 48.29,
    Verified: !0,
    Phon: 0.5519023412,
    Number2: 0.00111178,
    number3: -0.02365654,
    mail: "Laura@mail.com",
    LastName: "Callahan",
    FirstName: "Laura"
  }
];
export let employeeData = [
  {
    EmployeeID: 1,
    LastName: "Davolio",
    FirstName: "Nancy",
    Title: "Sales Representative",
    HireDate: new Date(704692800000),
    ReportsTo: 2
  },
  {
    EmployeeID: 2,
    LastName: "Fuller",
    FirstName: "Andrew",
    Title: "Vice President, Sales",
    HireDate: new Date(713764800000),
    ReportsTo: 2
  },
  {
    EmployeeID: 5,
    LastName: "Buchanan",
    FirstName: "Steven",
    Title: "Sales Manager",

    HireDate: new Date(750830400000),
    ReportsTo: 2
  },
  {
    EmployeeID: 3,
    LastName: "Leverling",
    FirstName: "Janet"
  },
  {
    EmployeeID: 4,
    LastName: "Peacock",
    FirstName: "Margaret"
  },
  {
    EmployeeID: 6,
    LastName: "Suyama",
    FirstName: "Michael"
  },
  {
    EmployeeID: 7,
    LastName: "King",
    FirstName: "Robert"
  },
  {
    EmployeeID: 8,
    LastName: "Callahan",
    FirstName: "Laura"
  },
  { EmployeeID: 9, LastName: "Dodsworth", FirstName: "Anne" }
];
